import React from 'react';
import Services from '../components/Services';
import Partners from '../components/Partners';
import SEO from '../components/SEO';

const ServicesPage = () => {
  return (
    <div>
      <SEO 
        title="Our Services | Mutual Funds, SIP, AIF, PMS | Rubicon Finservices"
        description="Comprehensive financial services from Rubicon Finservices - Mutual Funds, SIP, STP, SWP, AIF, PMS, and more. Partnered with India's top 20 AMCs. Expert investment solutions for every goal."
        keywords="mutual fund services, SIP investment, systematic investment plan, AIF, PMS, portfolio management, equity funds, debt funds, hybrid funds, retirement planning, wealth creation"
        ogImage="https://customer-assets.emergentagent.com/job_rubicon-funds/artifacts/7akuxub4_LOGO.png"
      />
      <Services />
      <Partners />
    </div>
  );
};

export default ServicesPage;
